import { createContext } from 'react';

export const BootstrapContext = createContext({});
